import React, { FC } from 'react'
import { Col, Form, Button, Row } from 'react-bootstrap';
import '../styles/loginStyles/success.scss';

import { Link, useNavigate, useParams } from 'react-router-dom';

import i18n from "../i18n/i18n"
import { useTranslation } from 'react-i18next';

// interface SuccessProps {
//     text: string
//     buttonText: string
//     action: () => {}
// }
const Success = () => {
    const { type } = useParams()
    const { t } = useTranslation()
    const navigate = useNavigate()

    const onSubmit = (event: any) => {
        event.preventDefault();

        // Handle form submission logic here
        const formData = new FormData(event.target);
        const email = formData.get('email');
        const password = formData.get('password');

        // Example: Log email and password to the console
        type === "registration" ?
            navigate("/Login/Login", { replace: true, })
            :
            navigate("/Register/PersonalInfo", { replace: true, })
        // You can add more logic here, like making an API call to sign in
    };

    function getText(str: string) {
        return t(`Success.${type}.${str}`)
    }
    return (
        <p>Success</p>
    );
}

export default Success